// extracted by mini-css-extract-plugin
export default {"chart_parent":"BarChartComponent_chart_parent__jO72F"};